import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.svg',
    styleUrls: ['./upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadComponent {}
